<template>
<!-- 研究列表的数据项 -->
  <div class="trialItem" v-loading="loading">
    <li class="resultItem">
      <h3>
        <span>{{ trialItemInfo.title_brief }}</span>
      </h3>
      <div class="labels">
        <div class="labelItem" v-show="trialItemInfo.regdate">
          <img class="icon" src="../assets/img/icon_label_calendar.png"/>
          <span class="text">{{ parseRegdate(trialItemInfo.regdate) }}</span>
        </div>
        <div class="labelItem" v-show="trialItemInfo.status">
          <img class="icon" src="../assets/img/icon_label_trial.png"/>
          <span class="text">{{ trialItemInfo.status }}</span>
        </div>
        <div class="labelItem" v-show="trialItemInfo.sample_size">
          <img class="icon" src="../assets/img/icon_label_person.png"/>
          <span class="text">{{ parseSampleSize(trialItemInfo.sample_size_type) }}: {{ trialItemInfo.sample_size }}</span>
        </div>
        <div class="labelItem" v-show="trialItemInfo.rct_phase">
          <img class="icon" src="../assets/img/icon_label_trial.png"/>
          <span class="text">{{ trialItemInfo.rct_phase && trialItemInfo.rct_phase.join(" ") }}</span>
        </div>
        <div class="labelItem" v-show="trialItemInfo.study_type">
          <img class="icon" src="../assets/img/icon_label_trial.png"/>
          <span class="text">{{trialItemInfo.study_type }}</span>
        </div>
      </div>
      <div class="rows">
        <div class="row">
          <div class="col regnum">
            <span class="label">注册号：</span>
            <span class="value">{{ trialItemInfo.registration }}</span>
          </div>
          <div class="col" v-show="trialItemInfo.acronym">
            <span class="label">研究简称：</span>
            <span class="value">{{ trialItemInfo.acronym }}</span>
          </div>
        </div>
        <div class="row" v-show="trialItemInfo.population">
          <span class="label">疾病：</span>
          <span class="value">{{ trialItemInfo.population && trialItemInfo.population.join('、') }}</span>
        </div>
        <div class="row" v-show="trialItemInfo.intervention">
          <span class="label">干预措施：</span>
          <ul class="bullet">
            <li v-for="(interventionItem,i) in trialItemInfo.intervention" :key="i">{{interventionItem[0]}}: {{ interventionItem[1] }}</li>
          </ul>
        </div>
        <div class="row" v-show="trialItemInfo.description">
          <span class="label">研究简介：</span>
          <div class="par">{{ trialItemInfo.description }}</div>
        </div>
      </div>
      <div class="actionBox">
        <a href="javascript:;" @click="handleTranslate"><img src="../assets/img/icon14.png" alt="">翻译</a>
        <a href="javascript:;" @click="showTrialDetail">
          <img src="../assets/img/icon15.png" alt="">
          查看详情
        </a>
        <a href="javascript:;" @click="collection">
          <img src="../assets/img/icon3-2.png" alt="" v-if="!trialItemInfo.is_collected">
          <img src="../assets/img/icon3-3.png" alt="" v-if="trialItemInfo.is_collected">
          {{ trialItemInfo.is_collected ? '已收藏' : '收藏' }}
        </a>
        <a href="javascript:;" @click="handleRelated" v-if="trialItemInfo.reference"><img src="../assets/img/icon_doc.png" alt="">相关文献</a>
        <a href="javascript:;" @click="handleSimilarTrial"><img src="../assets/img/icon_trial.png" alt="">相似研究</a>
      </div>
    </li>
  </div>
</template>
<script>
import { md5 } from "md5js";
import { webTrackerEvent } from "../utils/tracker";
import {trialCollect, trialTranslate } from '../service/getData'
export default {
  props: {
    trialItemData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      trialItemFullData: {},
      language: 'en',// en/cn
      loading: false,
      token: window.localStorage.getItem("PUBMEDSEARCHTOKEN"),
      openid: window.localStorage.getItem("PUBMEDSEARCHOPENID"),
    }
  },
  computed: {
    trialItemInfo() {
      return this.trialItemFullData[this.language];
    },
  },
  methods: {
    /**
     * 翻译
     */
    async handleTranslate() {
      if(this.language == 'cn') {
        this.language = 'en';
        return;
      }
      // 已经翻译过，直接取
      if(this.trialItemFullData.cn && typeof this.trialItemFullData.cn == 'object') {
        this.language = 'cn';
        return;
      }
      // 首次翻译
      this.loading = true;
      const clientId = "zeta";
      const secret = "4ede4aafbzd51cbz3e32bzb781bzee9813d17154";
      const ts = new Date().getTime();
      const tokenStr = `${clientId}.bz${ts}.bz${this.trialItemInfo.registration}.bz${secret}`;
      const token = md5(tokenStr, 32);
      const params = {
        client_id: clientId,
        ts: Number(ts),
        registration: String(this.trialItemInfo.registration),
        token: token,
      };
      const res = await trialTranslate(params);
      this.loading = false;
      const { status, data } = res.data;
      if(status == 0) {
        const { en } = this.trialItemFullData;
        const cnData = {
          ...en,
          ...data
        }
        this.trialItemFullData.cn = cnData;
        this.language = 'cn';
        // log
        let Logger = webTrackerEvent();
        Logger.push("action", "translate_clinical_trial");
        Logger.push("language", "en2cn");
        Logger.push("timeStamp", new Date().getTime());
        Logger.push("pmid", this.trialItemInfo.registration);
        Logger.push("pageUrl", window.location.href);
        Logger.push("token", this.token);
        Logger.push("openid", this.openid);
        Logger.logger();

      } else {
        this.$message.error('请重试！');
      }
    },
    /**
     * 收藏/取消收藏
     */
    collection() {
      if (!this.trialItemInfo.is_collected) {
        let Logger = webTrackerEvent();
        Logger.push("action", "collection_trial");
        Logger.push("timeStamp", new Date().getTime());
        Logger.push("pmid", this.trialItemInfo.registration);
        Logger.push("pageUrl", window.location.href);
        Logger.push("token", this.token);
        Logger.push("openid", this.openid);
        Logger.logger();
        trialCollect("POST", { registration: this.trialItemInfo.registration }).then((res) => {
          if (res.data.status === 0) {
            this.trialItemInfo.is_collected = true;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      } else {
        let Logger = webTrackerEvent();
        Logger.push("action", "cancel_collection_trial");
        Logger.push("timeStamp", new Date().getTime());
        Logger.push("pmid", this.trialItemInfo.registration);
        Logger.push("pageUrl", window.location.href);
        Logger.push("token", this.token);
        Logger.push("openid", this.openid);
        Logger.logger();
        trialCollect("DELETE", { registration: this.trialItemInfo.registration }).then((res) => {
          if (res.data.status === 0) {
            this.trialItemInfo.is_collected = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      }
    },
    /**
     * 查看详情
     */
    showTrialDetail() {
      let Logger = webTrackerEvent();
      Logger.push("action", "trialItem_viewDetail");
      Logger.push("timeStamp", new Date().getTime());
      Logger.push("pmid", this.trialItemInfo.registration);
      Logger.push("token", this.token);
      Logger.push("openid", this.openid);
      Logger.push("pageUrl", window.location.href);
      Logger.logger();
      const { href } = this.$router.resolve({
        name: "trialDetail",
        path: "/trialDetail",
        query: {
          registration: this.trialItemInfo.registration,
          searchType: "clinical"
        },
      });
      window.open(href);
    },
    /**
     * 相关文献
     */
    handleRelated() {
      const { registration, reference } = this.trialItemInfo;
      const { href } = this.$router.resolve({
        name: 'related',
        query: {
          registration,
          t: reference.join('.')
        }
      });
      window.open(href);
    },
    /**
     * 相似研究
     */
    handleSimilarTrial() {
      const { registration } = this.trialItemInfo;
      const { href } = this.$router.resolve({
        name: 'similarTrial',
        query: {
          registration,
          searchType: "clinical"
        }
      });
      window.open(href);
    },
    /**
     * 格式化注册日期标签
     */
    parseRegdate(value) {
      if(this.language == 'en') {
        return `Registered on ${value}`
      } else {
        return `${value} 注册`;
      }
    },
    /**
     * 格式化样本量标签
     */
    parseSampleSize(value) {
      if(value) return value;
      
      if(this.language == 'en') {
        return 'Sample size'
      } else {
        return '样本量' 
      }
    }
  },
  created() {
    this.trialItemFullData = {
      en: this.trialItemData,
      cn: undefined
    }
  },
  
}
</script>
<style lang="less" scoped>
.trialItem {
  .resultItem {
    padding: 10px;
    .labels {
      display: flex;
      align-items: center;
      margin: 10px 0;
      .labelItem {
        display: flex;
        align-items: center;
        height: 22px;
        margin-right: 16px;
        padding: 3px 8px 3px 4px;
        box-sizing: border-box;
        background: #3491FA1A;
        border-radius: 2px;
        color: #3491FA;
        .icon {
          width: 16px;
          height: 16px;
          margin-right: 4px;
        }
      }
    }
    .rows {
      .row {
        line-height: 22px;
        margin-bottom: 4px;
        .col {
          display: inline-block;
          &.regnum {
            width: 300px;
            margin-right: 24px;
          }
        }
        .bullet {
          li {
            padding-left: 10px;
            list-style: disc inside;
          }
        }
        .label {
          color: #387ED2;
        }
      }
    }
    .actionBox {
      display: flex;
      align-items: center;
      margin-top: 10px;
      a {
        display: flex;
        align-items: center;
        margin-right: 40px;
        img {
          margin-right: 8px;
          width: 30px;
        }
      }
    }
  }
}
  
</style>


// WEBPACK FOOTER //
// src/components/TriaItem.vue